import SearchIcon from '@mui/icons-material/Search';
import { Grid } from '@mui/material';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { EmailBounceStatus, IVendorSearchFilterDTO } from 'wisestep-api';
import {
  WsListingLoader,
  ScrollableTabs,
  TabTextVariant,
  WsPagination,
  SearchBar,
  WsButton,
  WsColors,
} from 'wisestep-base';

import NoDataFoundCard from '../../../../components/noDataFoundCard';
import { useVendorSearch } from '../../hooks';
import useGetVendorList from '../../hooks/useGetVendorList';
import { vendorListTabs, vendorsSearchDefaultQuery } from '../../utils/vendorsHelper';
import VendorListBanner from '../vendorListBanner/VendorListBanner';
import VendorTable from '../vendorTable/VendorTable';

const VendorListing = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const params = useParams();
  const [query, setQuery] = useState<IVendorSearchFilterDTO>(vendorsSearchDefaultQuery);
  const [pageNumber, setPageNumber] = useState<number>(1);
  query.vendorsInLists = [`${params.id}`];
  const [vendorList, totalCount] = useVendorSearch(query, setLoader);
  const methods = useForm();
  const vendor = useGetVendorList(`${params.id}`);

  const tabChange = {
    [0]: () => {
      query.emailBounceStatus = null;
      setQuery({ ...query });
    },
    [1]: () => {
      query.emailBounceStatus = EmailBounceStatus.Valid;
      setQuery({ ...query });
    },
    [2]: () => {
      query.emailBounceStatus = EmailBounceStatus.Invalid;
      setQuery({ ...query });
    },
    [3]: () => {
      query.emailBounceStatus = EmailBounceStatus.Unknown;
      setQuery({ ...query });
    },
    [4]: () => {
      query.emailBounceStatus = EmailBounceStatus.ValidationPending;
      setQuery({ ...query });
    },
  };
  const pageChange = (event, value) => {
    const updatedQuery = { ...query };
    updatedQuery.page = value;
    setQuery(updatedQuery);
    setPageNumber(value + 1);
  };
  const search = () => {
    query.query = methods.watch('search');
    setQuery({ ...query });
  };
  return (
    <FormProvider {...methods}>
      <Grid container spacing={1}>
        <Grid item xs={12} pb={2}>
          <VendorListBanner vendorList={vendor} />
        </Grid>
        <Grid xs={12} item pb={1}>
          {vendorList && (
            <WsPagination
              count={Math.ceil(totalCount / 50)}
              onChange={pageChange}
              itemsPerPage={50}
              pageNumber={query.page}
              defaultPage={pageNumber}
              isPageCount={true}
              type="Vendors"
              totalCount={totalCount}
            />
          )}
        </Grid>
        <Grid item xs={12} container>
          <Grid item xs={6}>
            <ScrollableTabs
              variant={TabTextVariant.SUB_TITLE}
              scrollList={vendorListTabs}
              getTabIndex={(index: number) => tabChange[index]()}
            />
          </Grid>
          <Grid item xs={6} container bgcolor={WsColors.White} alignItems="center" borderRadius={2}>
            <Grid item xs={10} bgcolor={WsColors.White}>
              {/* <ActivateFeature feature=""> */}
              <SearchBar
                name="search"
                placeholder="Search by Email,Name,SubscriptionStatus and EmailiStatus"
              />
              {/* </ActivateFeature> */}
            </Grid>
            <WsButton
              variant="outlined"
              size="small"
              onClick={() => search()}
              startIcon={<SearchIcon />}
            >
              Search
            </WsButton>
          </Grid>
        </Grid>
        <Grid item xs={12} container>
          {vendorList && vendorList.length > 0 && !loader ? (
            <VendorTable data={vendorList} />
          ) : loader ? (
            <Grid item xs={12}>
              <WsListingLoader />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <NoDataFoundCard text="No Vendors Found" />
            </Grid>
          )}
        </Grid>
        <Grid xs={12} item>
          <WsPagination
            count={Math.ceil(totalCount / 50)}
            onChange={pageChange}
            itemsPerPage={50}
            pageNumber={query.page}
            defaultPage={pageNumber}
            isPageCount={false}
            type="Vendors"
            totalCount={totalCount}
          />
        </Grid>
      </Grid>
    </FormProvider>
  );
};
export default VendorListing;
